import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/marketing/Navbar";
import Footer from "../../components/marketing/Footer";
import { TaxServicesSection } from "../../components/marketing/TaxServices";

export default function TaxServices() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <TaxServicesSection onOpen={(slug) => nav(`/tax/${slug}`)} />
      <Footer />
    </div>
  );
}
